export default `<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 18 18"
  height="18"
  width="18"
>
  <g
    transform="matrix(0.03156311,0,0,0.03156311,-1.38884,-7.4489755)"
  >
    <path
      d="m 614.286,749.714 q 0,7.429 -5.714,13.143 l -28.571,28.571 q -5.714,5.714 -13.143,5.714 -7.429,0 -13.143,-5.714 L 329.144,566.857 104.573,791.428 q -5.714,5.714 -13.143,5.714 -7.429,0 -13.143,-5.714 L 49.716,762.857 q -5.714,-5.714 -5.714,-13.143 0,-7.429 5.714,-13.143 L 316.002,470.285 q 5.714,-5.714 13.143,-5.714 7.429,0 13.143,5.714 l 266.286,266.286 q 5.714,5.714 5.714,13.143 z m 0,-219.428 q 0,7.429 -5.714,13.143 L 580.001,572 q -5.714,5.714 -13.143,5.714 -7.429,0 -13.143,-5.714 L 329.144,347.429 104.573,572 q -5.714,5.714 -13.143,5.714 -7.429,0 -13.143,-5.714 L 49.716,543.429 q -5.714,-5.714 -5.714,-13.143 0,-7.429 5.714,-13.143 L 316.002,250.857 q 5.714,-5.714 13.143,-5.714 7.429,0 13.143,5.714 l 266.286,266.286 q 5.714,5.714 5.714,13.143 z"
    />
  </g>
</svg>`;
